// src/pages/Customers.js
import React from 'react';

function Customers() {
  return <h1>Customers</h1>;
}

export default Customers;
